import { createAsyncAtom } from '../../lib/state';

const walletAddressAtom = createAsyncAtom<string | null>(async () => null);

export default walletAddressAtom;
